import { Heading } from "@medoma/components/Heading/Heading";
import styles from "./RegisterPatient.module.scss";
import { Outlet } from "react-router";
import { Trans } from "@lingui/react/macro";

const RegisterPatient = () => {
  return (
    <div className={styles.registerPatient}>
      <Heading level="h1">
        <Trans>Registrera patient</Trans>
      </Heading>
      <Outlet />
    </div>
  );
};

export default RegisterPatient;
